document.addEventListener('DOMContentLoaded', function () {
  const stacks = document.querySelectorAll('.js-stack-cards');

  stacks.forEach((stack) => {
    const items = stack.querySelectorAll('.js-stack-cards__item');
    items.forEach((item, i) => {
      item.style.setProperty('--index', i + 1);
    });
  });
});
